<template>
  <div>
    <div v-if="categories.length <= 0">
      No simulations for this user/app.
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    categories() {
      const testSimulationCategoryTypes = this.$store.getters['categoryTypes/testSimulationCategoryTypes'];
      const testSimulationCategoryIds = testSimulationCategoryTypes.map(c => c.id);
      let categories = this.$store.getters['categories/all'];
      categories = categories.
        filter( c => testSimulationCategoryIds.includes(c.categoryTypeId) && !c.parentCategoryId );
      return categories;
    },
  },
  created() {
    if (this.categories.length > 0) {
      this.$router.push({ name: 'sims#show', params: { simId: this.categories[0].id }});
    } else {
      // push user to home page
      this.$router.push({ name: 'home' });
    }
  },
};
</script>
